export default __webpack_public_path__ + "static/media/indexAlarm.2b46a245.png";